import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { UpdateTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/token/update-token.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { TokenUpdateFormStep1Controller } from '@app/feature/token/token-update/token-update-form-step-1/token-update-form-step-1.controller';
import { useUpdateTokenContext } from '@app/feature/token/token.context';

interface TokenUpdateFormControllerProps {
  onError: SubmitErrorHandler<
    Omit<UpdateTokenModel, 'customerId' | 'networkId'>
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Omit<UpdateTokenModel, 'customerId' | 'networkId'>
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const TokenUpdateFormController = (
  props: TokenUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useUpdateTokenContext();

  return (
    <MultiStepFormProvider<Omit<UpdateTokenModel, 'customerId' | 'networkId'>>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: [
            'token.expirationDate',
            'token.whitelist',
            'token.language',
            'token.firstName',
            'token.lastName',
            'token.vehicle',
            'token.comment',
          ],
          component: <TokenUpdateFormStep1Controller />,
        },
      ]}
    />
  );
};
